import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BlockList from '~/components/BlockList';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        flex-direction: row;
        flex-wrap: nowrap;
        gap: ${({ theme }) => theme.layout.gridGutter};
    }
`;

const Column = styled.div`
    flex-basis: ${({ width }) => (width ? width : '0')};
    flex-grow: 1;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        align-self: ${({ verticalAlignment }) => {
            switch (verticalAlignment) {
                case 'bottom':
                    return 'flex-end';
                default:
                    return verticalAlignment;
            }
        }};
    }

    figure {
        display: block;
        margin: 0;

        @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}) {
            margin: 20px 0;
        }
    }
`;

const Columns = ({
    columns = [],
    anchor = '',
    verticalAlignment = '',
    className = ''
}) => (
    <Container {...(anchor ? { id: anchor } : {})} {...{ className }}>
        {columns.map(
            ({ attributes: { anchor, width, className }, order, blocks }) => (
                <Column
                    key={anchor ? anchor : order}
                    {...{ width, verticalAlignment, className }}
                    {...(anchor ? { id: anchor } : {})}
                >
                    <BlockList {...{ blocks }} />
                </Column>
            )
        )}
    </Container>
);

Columns.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            attributes: PropTypes.shape({
                anchor: PropTypes.string,
                width: PropTypes.string,
                className: PropTypes.string
            }),
            blocks: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired
                })
            ),
            order: PropTypes.number.isRequired
        })
    ),
    anchor: PropTypes.string,
    className: PropTypes.string,
    verticalAlignment: PropTypes.string
};

export default Columns;
